import React, { useState } from 'react';
import { Modal, ModalBody, ModalFooter, ModalHeader } from "../../common/modal";
import api from '../../../services/axios';
import Swal from "sweetalert2";

const AddLink = ({ isOpen, path, folderId, isPublic, closeCallback, successCallback }) => {

    const [inputname, setInputValue] = useState('');
    const [inputLink, setInputLink] = useState('');
    const [subBtnDisabled, setSubBtnDisabled] = useState(false);

    const handleNameChange = (e) => {
        setInputValue(e.target.value);
    };
    const handleLinkChange = (e) => {
        setInputLink(e.target.value);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSubBtnDisabled(true);
        if (inputname === '' || inputLink === '') {

            var message = inputname === '' ? 'Please enter link name' : 'Please enter link URL';
            Swal.fire({
                position: "center",
                icon: "info",
                text: message,
                showConfirmButton: true,
                timer: 3000,
                timerProgressBar: true
            });
            setSubBtnDisabled(false);
        }
        else {
            try {
                const { data } = await api.post("link/AddLink", {
                    name: inputname,
                    isPublic: isPublic,
                    linkUrl: inputLink,
                    folderid: folderId
                });
                if (data.statusCode === 200) {
                    if (successCallback)
                        successCallback(folderId);
                    closeCallback();
                    Swal.fire({
                        position: "center",
                        icon: "success",
                        text: 'Link added successfully',
                        showConfirmButton: true,
                        timer: 3000,
                        timerProgressBar: true
                    });
                }
            } catch (error) {
                console.error('Error fetching data:', error);
            }
            setInputValue('');
            setInputLink('');
        }
        setSubBtnDisabled(false);
    }


    return (
        <Modal isLarge={false} isOpen={isOpen}>
            <ModalHeader>
                <h5 className="modal-title">
                    <img src="/Assets/link.svg" alt="Add Link" /> Add Link
                </h5>
            </ModalHeader>
            <ModalBody>
                
                <div class="mb-2" >
                    <label className="folder-btm-text">Name</label>
                    <input
                        type="text"
                        className="form-control folder-textbox"
                        placeholder='Enter Link Name'
                        value={inputname}
                        onChange={handleNameChange}
                    />
                </div>
                <div class="mb-2">
                    <label className="folder-btm-text">Link</label>
                    <input
                        type="text"
                        className="form-control folder-textbox"
                        placeholder='Enter Link URL'
                        value={inputLink}
                        onChange={handleLinkChange}
                    />
                </div>

            </ModalBody>
            <ModalFooter>
                <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={closeCallback}
                >
                    Cancel
                </button>
                <button disabled={subBtnDisabled} type="button" onClick={handleSubmit} className="btn btn-primary">
                    Add
                </button>
            </ModalFooter>
        </Modal>);
};
export default AddLink;